import React, { memo } from 'react';
import { produce } from 'immer';

import { ESPChart } from '@components';
import classnames from 'classnames';
import useTheme from '@hooks/useTheme';

const hasData = (data = {}) =>
  Object.values(data)
    .map((item) => item.eps.length > 0)
    .filter((item) => item).length > 0;

const formatEpsData = (data = {}) => {
  try {
    return produce(data, (draft) => {
      const { buyer, target } = draft;

      buyer.eps = buyer.eps.filter(
        (item) => !item[0].displayEndDate.includes('LTM'),
      );

      target.eps = target.eps.filter(
        (item) => !item[0].displayEndDate.includes('LTM'),
      );
      const buyerYears = buyer.eps.map((epsData) => epsData[0].displayEndDate);
      const targetYears = target.eps.map(
        (epsData) => epsData[0].displayEndDate,
      );

      const years = Array.from(new Set([...buyerYears, ...targetYears]))
        .map((year) => Number(year.replace(/[^0-9]/g, '')))
        .sort((a, b) => a - b);

      const matchYears = (data = []) => {
        const result = [],
          firstYearOfData = data[0][0].displayEndDate;

        for (const y of years) {
          const currentYear = `FY${y}`;
          if (currentYear === firstYearOfData) {
            break;
          }

          result.push(null);
        }
        return result.concat(data);
      };

      const fixCurrency = (currencyISOCode) => {
        if (!currencyISOCode || currencyISOCode === 'Unknown') {
          return '';
        }

        return currencyISOCode;
      };

      const formatData = (data) => {
        data.eps = matchYears(data.eps);
        data.currencyISOCode = fixCurrency(data.currencyISOCode);
      };

      formatData(buyer);
      formatData(target);
    });
  } catch (error) {
    return data;
  }
};

function EPS({ currentId, others: chartData, ...restProps }) {
  const { theme } = useTheme();
  const isLightMode = theme === 'light';
  if (!hasData(chartData)) {
    return (
      <div className="analysis-right-wrapper">
        <div className="title">Earnings Per Share</div>
        <div className="esp-chart-wrapper">
          <div className="no-data">No Data </div>
        </div>
      </div>
    );
  }

  return (
    <div className="analysis-right-wrapper">
      <div className="title">Earnings Per Share</div>
      <div
        className={classnames('esp-chart-wrapper', {
          'highcharts-dark': !isLightMode,
          'highcharts-light': isLightMode,
        })}
      >
        <ESPChart data={formatEpsData(chartData)} />
      </div>
    </div>
  );
}

export default memo(EPS);
